import styled from 'styled-components';

export const StyledForm = styled.form`
  display: flex;
  flex-direction: column;
  width: 100%;
  gap: 16px;

  @media (min-width: 768px) {
    gap: 24px;
  }
`;

export const BtnWrapper = styled.div`
  display: flex;
  align-items: center;
  gap: 24px;

  @media (min-width: 768px) {
    gap: 32px;
  }
`;

export const Btn = styled.button`
  padding: 14px 32px;
  border: none;
  border-radius: ${props => props.theme.radii.pill};
  font-family: ${props => props.theme.fonts.body};
  font-weight: 600;
  font-size: 14px;
  color: ${props => props.theme.colors.textPrimary};
  background: ${props => props.theme.colors.secondary};
  cursor: pointer;
  transition: ${props => props.theme.transition.main};

  &:hover,
  &:focus-visible {
    background: ${props => props.theme.colors.hoverColor};
  }

  @media (min-width: 768px) {
    padding: 16px 44px;
    font-size: 16px;
  }
`;

export const ForgotPasswordBtn = styled.button`
  background: transparent;
  border: none;
  font-family: ${props => props.theme.fonts.body};
  font-size: 13px;
  font-weight: 600;
  color: ${props => props.theme.brand.muted};
  text-decoration: underline;
  text-underline-offset: 2px;
  cursor: pointer;
  transition: ${props => props.theme.transition.main};

  &:hover,
  &:focus-visible {
    color: ${props => props.theme.colors.hoverColor};
  }

  @media (min-width: 768px) {
    font-size: 15px;
  }
`;
